import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import {getDetailData} from "../../models/bankModel";
import {fetchBankById} from "../../store/bank-setting-slice";

const BankDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);


    useEffect(() => {
        dispatch(fetchBankById({...userRole, id: params.bankId})); // Adjust based on your actual Redux action
    }, [dispatch, params.bankId, userRole]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.bankSetting); // Adjust based on your Redux slice

    const item = items.find(item => item.id === params.bankId); // Ensure correct id matching
    const detailData = getDetailData({item}); // Adjust this to fit how you process data for details

    return (
        <>
            <SubHeader title="Bank Details">
                <Button to="../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>}
            </div>
        </>
    );
};

export default BankDetail;
